export enum CatType {
  DOMESTIC = 'DOMESTIC',
  EXTERIOR = 'EXTERIOR',
}

export const getCatTypeLabel = (value: CatType): string => {
  switch (value) {
    case CatType.DOMESTIC:
      return $localize`Domestique`;
    case CatType.EXTERIOR:
      return $localize`Extérieur`;
    default:
      return '';
  }
};
